import PropTypes from 'prop-types';
import React from 'react';

import './ExitButton.scss';

const Exit = ({ onClick }) => (
	<button className="exit-icon" name="exit-icon" onClick={onClick}>
		<i className="icon exit icon-close" title="Sluiten" />
	</button>
);

Exit.propTypes = {
	onClick: PropTypes.func,
};

export default Exit;
